import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Grid, Card, CardHeader, CardContent, Box, IconButton } from '@mui/material';

import DropdownComponent from "../../Components/UI/DropdownComponent";
import FilterModal from '../../Components/Modal/Filter';
import StudentProgress from '../../Components/ProgressBar/StudentProgress';

import { getClassNames } from "../../Js/Common";
import { getLearnerLeaderBoard } from "./Services";
import { currentMonth, getFormatedDate } from "../../Js/TimeAndDate";
import { makeStyles } from "@material-ui/core/styles";
import Placeholder from "../../Components/UI/Placeholder";

const LearnerLeaderBoard = (props) => {
    //Hooks
    const styles = useStyles();

    // Redux state
    const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);

    // State    
    const [allClasses, setAllClasses] = useState([]);
    const [selectedClass, setSelectedClass] = useState(null);
    const [learnersData, setLearnersData] = useState([]);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);

    // React logic hooks
    useEffect(() => {
        const initialRender = async () => {
            let objCurrentMonth = currentMonth('YYYY-MM-DD');
            setStartDate(objCurrentMonth.startOfMonth);
            setEndDate(objCurrentMonth.endOfMonth);

            let classesData = await getClassNames(userInfo.site_uuid);
            if (classesData.length === 0) {
                return;
            }

            setAllClasses(classesData);
            return;
        }
        initialRender();
    }, []);

    useEffect(() => {
        if (selectedClass != null && endDate != null) {
            classWiseLeaderBoard();
        }
    }, [selectedClass]);

    useEffect(() => {
        if (endDate != null && selectedClass != null) {
            classWiseLeaderBoard();
        }
    }, [endDate]);


    const classWiseLeaderBoard = async () => {
        // console.log("selectedClass====>", selectedClass);
        let params = {
            query: {
                startDate: startDate,
                endDate: endDate,
                site_uuid: userInfo.site_uuid,
                classId: selectedClass
            }
        }
        let resUsers = await getLearnerLeaderBoard(params);
        // console.log("resUsers=====>", resUsers);
        setLearnersData(resUsers.data.data);
    };

    const handleFilterReport = (childParams) => {
        // console.log("childParamas", childParams);
        setStartDate(childParams.start_date);
        setEndDate(childParams.end_date);
    };

    return (
        <Grid container sx={{ flexDirection: "row" }}>
            <Grid item xs={12}>
                <Card sx={{ borderRadius: 5, boxShadow: '3px 3px 5px 1px #dddddd' }}>
                    <CardHeader
                        titleTypographyProps={{ fontSize: '1.2vw', fontWeight: '700', textAlign: 'left', pl: 2 }}
                        subheaderTypographyProps={{ fontSize: '0.9vw', fontWeight: '600', textAlign: 'left', pl: 2 }}
                        sx={{ backgroundColor: '#3eda00ff', color: '#5f5600ff' }}
                        action={
                            <>
                                {allClasses.length > 0 &&
                                    <DropdownComponent
                                        defaultSelected={allClasses[0]}
                                        dropDownData={allClasses}
                                        fetchBySelectedValue={(classId) => { setSelectedClass(classId) }}
                                        disableVal={false}
                                    />
                                }
                                <IconButton
                                    variant="text"
                                    sx={{ fontSize: '1.2rem', fontWeight: '600', color: '#5f5600ff', padding: 0, mt: 0.3 }}
                                >
                                    <FilterModal
                                        press={handleFilterReport}
                                        defaultSelectedValues={props.defaultSelectedValues}
                                        isAllTrainer={false}
                                    />
                                </IconButton>
                            </>
                        }
                        title={"Learners' Leader Board"}
                        subheader={(
                            getFormatedDate(startDate, 'DD MMM YYYY') + ' - ' + getFormatedDate(endDate, 'DD MMM YYYY')
                        )}
                    >
                    </CardHeader>
                    <CardContent className={styles.scrollBar} sx={{ height: '48vh', overflow: 'auto' }}>
                        {(learnersData && learnersData.length > 0) ? (
                            learnersData.map((data, index) => {
                                return (
                                    <Box sx={{ pl: 4, pr: 4, py: 1, mr: 2 }}>
                                        <StudentProgress
                                            key={`learner_report_${index}`}
                                            data={data}
                                            classes={allClasses}
                                            index={index}
                                            isCupDisplay={true}
                                        />
                                    </Box>
                                )
                            })) : (
                            <Placeholder
                                primaryText="No Learners"
                                secondaryText="No data found!"
                                image="assign"
                            ></Placeholder>
                        )}
                    </CardContent>
                </Card>
            </Grid>
        </Grid>
    );
};
const useStyles = makeStyles({
    scrollBarHeight: {
        "&::-webkit-scrollbar": {
            width: "0.0em",
        },
        "&::-webkit-scrollbar-track": {
            backgroundColor: "#ffe600ff",
            "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
            borderRadius: 5,
        },
        "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#5f5600ff",
            borderRadius: 5,
        },
    },
    scrollBar: {
        "&::-webkit-scrollbar": {
            width: "0.6em",
        },
        "&::-webkit-scrollbar-track": {
            backgroundColor: "#ffe600ff",
            "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
            borderRadius: 5,
        },
        "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#5f5600ff",
            borderRadius: 5,
        },
    },
});
export default LearnerLeaderBoard; 